window.config = window.config || {};

window.config.language = window.config.language || {
  availableLanguages: ['en', 'it'],
  defaultLanguage: 'en'
};
